import { MLHelper } from '@bimser/core';

export function calculateDefinitionColumnsDisplayValue({ title }) {
	return MLHelper.getMLText(title);
}
